import { buildTextNodeData } from '../nodes/Text/syncTextNode';
import { type AppNode, type TextNodeData } from '../types';

export function getTextNodeData(node: AppNode): TextNodeData | undefined {
  if (node.type !== 'text') {
    return undefined;
  }

  if (!node.data.text?.trim()) {
    return undefined;
  }

  return buildTextNodeData(node.data);
}
